module.exports = __webpack_public_path__ + "static/img/m9.56f240d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m9.jpg
// module id = 1jP8
// module chunks = 1